import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Platnosc } from '../../shared/models/platnosc.model';
import { ZakresDat } from '../../shared/models/zakres-dat.model';
import { FormatowanieDatService } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class PlatnoscService {

  constructor(
    private http: HttpClient,
    private formatowanieDat: FormatowanieDatService,
  ) { }

  getPlatnosci(zakresDat: ZakresDat): Observable<Platnosc[]> {
    const params = new HttpParams()
      .set('dataOd', this.formatowanieDat.format(zakresDat.dataOd))
      .set('dataDo', this.formatowanieDat.format(zakresDat.dataDo));

    return this.http.get<Platnosc[]>('/api/platnosc', { params: params });
  }
}
